import { createMutationHook, useApiQuery } from 'queries/common';

import firehydrantAPI from '../../helpers/firehydrantAPI';

export const useStatusPages = (params = {}) => {
  const query = useApiQuery(['statusPages', 'list', params], () =>
    firehydrantAPI.get('/nunc_connections', params),
  );

  return {
    ...query,
    data: query.data?.data?.data ?? [],
    pagination: query.data?.data?.pagination ?? {},
  };
};

export const useStatusPage = (id, params = {}, options) => {
  const query = useApiQuery(
    ['statusPages', 'detail', id],
    () => firehydrantAPI.get(`/nunc_connections/${id}`, params),
    options,
  );

  return {
    ...query,
    data: query.data?.data ?? {},
  };
};

export const useCreateStatusPage = (options) =>
  createMutationHook((body) => firehydrantAPI.post('/nunc_connections', body))(
    options,
  );

export const useUpdateStatusPage = (options) =>
  createMutationHook((body) =>
    firehydrantAPI.put(`/nunc_connections/${body.id}`, body),
  )(options);

export const useDeleteStatusPage = (options) =>
  createMutationHook((id) => firehydrantAPI.delete(`/nunc_connections/${id}`))(
    options,
  );
